import { render, staticRenderFns } from "./AddAreaForm.vue?vue&type=template&id=fe8b17e8"
import script from "./AddAreaForm.vue?vue&type=script&lang=js"
export * from "./AddAreaForm.vue?vue&type=script&lang=js"
import style0 from "./AddAreaForm.vue?vue&type=style&index=0&id=fe8b17e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports